<div :class="[showGif ? 'background-depan' : 'background-depan-end']">
    <div class="flex align-content-end flex-wrap " style="height: 70%">
        <div class="flex align-items-center justify-content-center ">
            <p-button severity="danger" rounded @click="$router.push('/home')">
                <b class="text-3xl">MULAI</b>
            </p-button>
        </div>
    </div>
</div>